var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaintRollerAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C3.89543 2 3 2.89543 3 4V4.43747C1.97566 4.8375 1.25 5.83401 1.25 7V10C1.25 11.5188 2.48122 12.75 4 12.75H10.25V15H10C9.44771 15 9 15.4477 9 16V21C9 21.5523 9.44771 22 10 22H12C12.5523 22 13 21.5523 13 21V16C13 15.4477 12.5523 15 12 15H11.75V12.75H18C19.5188 12.75 20.75 11.5188 20.75 10V7C20.75 5.83401 20.0243 4.8375 19 4.43747V4C19 2.89543 18.1046 2 17 2H5ZM3.01336 6.23242C3.12852 7.22749 3.97404 8 5 8H17C18.026 8 18.8715 7.2275 18.9866 6.23242C19.1517 6.44427 19.25 6.71065 19.25 7V10C19.25 10.6904 18.6904 11.25 18 11.25H4C3.30964 11.25 2.75 10.6904 2.75 10V7C2.75 6.71065 2.84831 6.44426 3.01336 6.23242Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintRollerAlt1);
export default __webpack_public_path__ + "static/media/paint-roller-alt-1.c945022be216d27a72753276c6be6b47.svg";
export { ForwardRef as ReactComponent };